module.exports = __webpack_public_path__ + "img/perm_contact_calendar.50819aab.svg";